import { ConversationStatus } from '@provision/conversation-types';
import { useGroupRules, UserGroupRules } from 'src/graphql/entities/group-rules';

interface UseCanUpdateConversationInput {
  conversationStatusId: string | undefined;
  isDeleted: boolean | undefined;
}

export function useCanUpdateConversation({
  conversationStatusId,
  isDeleted,
}: UseCanUpdateConversationInput): boolean {
  const { groupRules } = useGroupRules();
  return (
    (conversationStatusId as ConversationStatus) !== ConversationStatus.Closed &&
    groupRules[UserGroupRules.AccessToUpdateConversation] !== false &&
    !isDeleted
  );
}
